import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import type { WithdrawalsResponse } from '../types/withdrawals.types'
import { getSelectedTaxHarvestingFinancialYear } from './taxHarvestingSummary'

function resolveFinancialYear(input?: unknown): number {
  if (typeof input === 'number' && Number.isFinite(input) && input > 0) {
    return input
  }

  if (input && typeof input === 'object' && 'queryKey' in input) {
    const financialYearFromQueryKey = (input as { queryKey?: unknown[] })?.queryKey?.[1]
    if (
      typeof financialYearFromQueryKey === 'number' &&
      Number.isFinite(financialYearFromQueryKey) &&
      financialYearFromQueryKey > 0
    ) {
      return financialYearFromQueryKey
    }
  }

  return getSelectedTaxHarvestingFinancialYear()
}

export async function fetchWithdrawals(financialYear?: number | { queryKey?: unknown[] }): Promise<WithdrawalsResponse> {
  const resolvedFinancialYear = resolveFinancialYear(financialYear)
  const response = await axiosInstance.get<WithdrawalsResponse>(
    `${mobileBackendUrl}/v2/tax-harvesting/withdraw-transactions?financialYear=${resolvedFinancialYear}`
  )
  if (!response?.data) {
    throw new Error('Failed to fetch tax harvesting withdrawals')
  }
  return response.data as WithdrawalsResponse
}
